/* @flow */
import * as React from 'react';
import ReactModal from 'react-modal';
import { withRouter } from 'app/context/Router';
import GroupCreateModal from 'groups/components/GroupCreateModal';
import getRedirectLocationAfterGroupCreation from 'utils/getRedirectLocationAfterGroupCreation';

type Props = {
  router: {
    replace: Function,
  },
};

class CreateGroupHandler extends React.Component<Props, {}> {
  toRoot = () => this.props.router.replace('/classes');
  toNewClass = g => this.props.router.replace(getRedirectLocationAfterGroupCreation(g));

  render() {
    return (
      <ReactModal isOpen>
        <GroupCreateModal onCreate={this.toNewClass} onRequestHide={this.toRoot} />
      </ReactModal>
    );
  }
}

export default withRouter(CreateGroupHandler);
